import { render, staticRenderFns } from "./UnitsList.vue?vue&type=template&id=28120be4&scoped=true&"
import script from "./UnitsList.vue?vue&type=script&lang=js&"
export * from "./UnitsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28120be4",
  null
  
)

export default component.exports